import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import type { BlockingLoadingState } from './types';
import { setBlockingLoadingAsync } from './actions';

export const setBlockingLoadingAsyncBuilder = (
  builder: ActionReducerMapBuilder<BlockingLoadingState>,
) => {
  builder.addCase(setBlockingLoadingAsync.fulfilled, (state, action) => {
    state.isBlockingLoading = action.payload;
  });
};
